<div [class.loading]="IsLoading" class="related_advertisements overflow-hidden position-relative">
    <ng-container *ngIf="IsLoading">
        <app-loader [preventScroll]="true" [sm]="true" size="fa-5x" />
    </ng-container>
    <div class="info_related" >
        <div class="container">
            <ng-container *ngIf="!IsLoading">
                <h4 class="title color_black">
                    {{ Advertisements.length == 0 ? 'لا يوجد اي اعلانات مشابه لهذا الاعلان' : 'فرص مشابهه'}}
                </h4>
            </ng-container>
            <ng-container *ngIf="Advertisements.length > 0">
                <owl-carousel-o [options]="OwlOption">
                    <ng-template carouselSlide *ngFor="let advertisement of Advertisements">
                        <div class="wrap_box">
                            <app-advertisement-card [info]="advertisement" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </ng-container>
        </div>
    </div>   
</div>